import React from "react";
import PropTypes from "prop-types";
import { useNavigation, useResolvedPath } from "react-router-dom";
import InnerPageLoader from "../InnerPageLoader";
PrivatePage.propTypes = {
    children: PropTypes.node.isRequired,
    disablePageLoader: PropTypes.func
};
export default function PrivatePage(param) {
    var children = param.children, disablePageLoader = param.disablePageLoader;
    /**
     * By default always show the page loader
     * unless explicitly told otherwise via "disablePageLoader()"
     */ var navigation = useNavigation();
    var resolvedPath = useResolvedPath();
    var showLoader = disablePageLoader && navigation.state === "loading" ? !disablePageLoader(resolvedPath.pathname, navigation.location.pathname) : navigation.state === "loading";
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative m-3 flex h-full flex-grow flex-col lg:m-5"
    }, showLoader ? /*#__PURE__*/ React.createElement(InnerPageLoader, null) : children);
}
